// extracted by mini-css-extract-plugin
export default {"modalWrapper":"modalWrapper-IVQti","closeIcon":"closeIcon-X4OLZ"};